import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const UpPointingTriangleIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon viewBox="0 0 6 3" {...props}>
    <path
      d="M2.78787 0.212132L0.512132 2.48787C0.323143 2.67686 0.456993 3 0.724264 3H5.27574C5.54301 3 5.67686 2.67686 5.48787 2.48787L3.21213 0.212132C3.09497 0.0949748 2.90503 0.0949747 2.78787 0.212132Z"
      fill="currentColor"
    />
  </Icon>
);
